import React from 'react';
import './AboutMe.css';

const AboutMe = () => {
    return (
        <div className='mt-6'>
           <h1 className='text-center project-text text-5xl mb-2'>About Me</h1>
           <p className='text-justify about-me lg:mx-20 lg:text-3xl'>Hey It's Maruf Mozumder. I'm a fourth year college student living in Milan, Italy. I've been practising MERN Stack Development from the last 7 months. I hope you've already watched some of my demo projects. Day by day I'm continuosly improving myself. If you do need any kind of service/help from me, feel free to leave a message down here.</p> 
        </div>
    );
};

export default AboutMe;